class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M6.058.982a4.9 4.9 0 0 0-2.7.8l3.2 3.2a1.05 1.05 0 0 1 .1 1.5 1.05 1.05 0 0 1-1.5-.1l-3.3-3.2a4.92 4.92 0 0 0-.85 2.85 5.07 5.07 0 0 0 5.05 5.05c.437.003.874-.048 1.3-.15l3.35 3.35a2.51 2.51 0 0 0 3.55-3.55l-3.35-3.35c.101-.425.152-.862.15-1.3a5 5 0 0 0-5-5.1Zm4 5.05c-.001.356-.052.71-.15 1.05l-.15.55 3.75 3.75a1.439 1.439 0 0 1 .45 1.05 1.36 1.36 0 0 1-.45 1.05 1.449 1.449 0 0 1-2.1 0l-3.75-3.75-.55.15c-.342.1-.695.15-1.05.15a4.135 4.135 0 0 1-2.85-1.15 3.815 3.815 0 0 1-1.2-2.85c0-.371.05-.741.15-1.1l2.2 2.2a2.07 2.07 0 0 0 2.95.1 2.07 2.07 0 0 0-.1-2.95l-2.2-2.2c.323-.102.66-.152 1-.15a4.135 4.135 0 0 1 2.85 1.15 4.245 4.245 0 0 1 1.2 2.95Z"></path></svg>';
  }
}
const e = "pi-wrench";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
